import React from "react";
import { Modal, Table } from "antd";

const ReqCodeModal = ({ visible, onClose, onRowClick, data }) => {
  const columns = [
    { title: "Req Date", dataIndex: "req_date", key: "req_date" },
    { title: "Req Code", dataIndex: "req_code", key: "req_code" },
    {
      title: "Employee Name",
      dataIndex: "emp_cd",
      key: "emp_cd",
    },
    { title: "Department", dataIndex: "dept", key: "dept" },
    // { title: "Dealer Name", dataIndex: "dealer", key: "dealer" },
    // { title: "Remarks", dataIndex: "remarks", key: "remarks" },
  ];

  return (
    <Modal
      title="Select Any Requition"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      style={{ backgroundColor: "#f0f0f0" }} // Setting modal background color to light gray
      bodyStyle={{ backgroundColor: "#f0f0f0" }} // Styling the body content as well
    >
      <Table
        dataSource={data}
        columns={columns}
        onRow={(record) => {
          return {
            onClick: () => {
              onRowClick(record);
              onClose();
            },
          };
        }}
      />
    </Modal>
  );
};

export default ReqCodeModal;
